export enum LogLevel {
    Undefined = -1,
    Debug = 0,
    Info = 1,
    Warn = 2,
    Error = 3
}

export interface ILog {
    debug(message: string): void;
    info(message: string): void;
    warn(message: string): void;
    error(message: string): void;
}

export interface ILogListener {
    push(message: string): void;
}

export class AlertLogListener implements ILogListener {
    public push(message: string): void {
        alert(message);
    }
}

export class ConsoleLogListener implements ILogListener {
    public push(message: string): void {
        console.log(message);
    }
}

export class Log implements ILog {

    private source: string;

    constructor(source: any, private level: LogLevel = LogLevel.Undefined) {
        if (source && source.constructor && source.constructor.name && source.constructor.name != 'String') {
            this.debug("Source is a constructor: " + source.constructor.name);
            this.source = source.constructor.name;
        } else if (source) {
            this.debug("Source is any object: " + source.toString());
            this.source = source.toString();
        } else {
            this.debug("Source is unknown");
            this.source = "unknown";
        }
    }

    private static pattern: string = "{timestamp} {level} [{source}]: {message}";
    public static level = LogLevel.Error;
    private static listeners: ILogListener[] = [
        new ConsoleLogListener()
    ];

    public static addListener(listener: ILogListener): void {
        this.listeners.push(listener);
    }

    private out(level: LogLevel, message: string): void {
        if (level >= (this.level > LogLevel.Undefined ? this.level : Log.level)) {
            var s = Log.pattern
                .replace("{timestamp}", (new Date()).toLocaleString())
                .replace("{level}", level.toString().toUpperCase())
                .replace("{source}", this.source || "Log")
                .replace("{message}", message);
            for (var index in Log.listeners) {
                try {
                    Log.listeners[index].push(s);
                } catch (e) {}
            }
        }
    }

    public debug(message: string): void {
        this.out(LogLevel.Debug, message);
    }

    public info(message: string): void {
        this.out(LogLevel.Info, message);
    }

    public warn(message: string): void {
        this.out(LogLevel.Warn, message);
    }

    public error(message: string): void {
        this.out(LogLevel.Error, message);
    }
}

/**
* Hack in support for Function.name for browsers that don't support it.
* IE, I'm looking at you.
**/
if (Function.prototype['name'] === undefined && Object.defineProperty !== undefined) {
    Object.defineProperty(Function.prototype, 'name', {
        get: function () {
            var funcNameRegex = /function\s([^(]{1,})\(/;
            var results = (funcNameRegex).exec((this).toString());
            return (results && results.length > 1) ? results[1].trim() : "";
        },
        set: function (value) { }
    });
}